import { useState, useEffect, useRef, useCallback } from 'react';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import msLocale from '@fullcalendar/core/locales/ms';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EventPopup from '../components/PopEvent';
import AddEvent from '../components/AddEvent';
import Modal from '../components/Modal';
import { doc, getDoc, updateDoc, deleteDoc, getDocs, collection, query, where, orderBy } from "firebase/firestore";
import { deleteEvent, saveEvent } from "../services/mosqueContentRepository";
import { db, firestoreAsatizah, firestore } from '../utils/FirebaseConfig';
import { generateCalendarPdf } from "../utils/generateCalendarPdf";
import { FaFileDownload, FaSpinner } from "react-icons/fa";
import { toYMD } from "../utils/recurringUtils";
import { resolveMaybeStorageUrl } from "../utils/resolveMaybeStorageUrl";
import { useSearchParams } from 'react-router-dom';


import '../App.css';
import '../styles/Calendar.css';


const safeImg = (v) => {
    const s = String(v || "");
    return s.startsWith("data:image/") ? "" : s;
};

const pickSpeakerImage = (sp, fallback = "") => {
    const v =
        sp?.__img ||
        sp?.image ||
        sp?.gambar ||
        sp?.photoURL ||
        sp?.avatar ||
        sp?.profileImage ||
        fallback;

    return safeImg(v);
};

const normalizeName = (s = "") => String(s).toLowerCase().replace(/[.\s]/g, "");

const parseYMD = (ymd) => {
    const [y, m, d] = String(ymd || "").split("-").map(Number);
    return new Date(y, (m || 1) - 1, d || 1);
};

const buildStartFromDateTime = (baseDate, timeStr) => {
    const [hh, mm] = (timeStr || "00:00").split(":").map(Number);
    const d = new Date(baseDate);
    d.setHours(hh || 0, mm || 0, 0, 0);
    return d;
};



function Calendar({ isMobile, subscriptionEnd }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedDate, setSelectedDate] = useState(null);
    const [eventTitle, setEventTitle] = useState('');
    const [speakerName, setSpeakerName] = useState('');
    const [speakerImage, setSpeakerImage] = useState('');
    const [speakerPosition, setSpeakerPosition] = useState('');
    const [posterImage, setPosterImage] = useState('');
    const [startTime, setStartTime] = useState('19:30');
    const [events, setEvents] = useState([]);
    const [asatizahData, setAsatizahData] = useState([]);

    const [selectedEvent, setSelectedEvent] = useState(null);
    const [modalTambah, setModalTambah] = useState(false);
    const [modalProgram, setModalProgram] = useState(false);
    const [eventId, setEventId] = useState(null);
    const calendarRef = useRef(null);
    const userProfile = JSON.parse(localStorage.getItem('userProfile') || "{}");
    const mosqueId = userProfile?.mosqueId || "";
    const [mosqueNameState, setMosqueNameState] = useState("");
    const [mosqueLogoUrlState, setMosqueLogoUrlState] = useState("");
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const [etvColorState, setEtvColorState] = useState("#7A1777");
    const [pendingException, setPendingException] = useState(null);

    const [addFormNonce, setAddFormNonce] = useState(0);

    useEffect(() => {
        if (searchParams.get('new') !== '1') return;

        setEventId(null);
        setSelectedEvent(null);
        setEventTitle('');
        setSpeakerName('');
        setSpeakerImage('');
        setSpeakerPosition('');
        setPosterImage('');
        setStartTime('19:30');
        setPendingException(null);
        setSelectedDate(new Date());
        setAddFormNonce((current) => current + 1);
        setModalTambah(true);

        const nextParams = new URLSearchParams(searchParams);
        nextParams.delete('new');
        setSearchParams(nextParams, { replace: true });
    }, [searchParams, setSearchParams]);


    const resetAddForm = () => {
        setEventId(null);
        setSelectedEvent(null);

        setEventTitle("");
        setSpeakerName("");
        setSpeakerImage("");
        setSpeakerPosition("");
        setPosterImage("");

        setStartTime("19:30"); // atau "" kalau kau nak kosong
        setPendingException(null);
    };



    const isSelfSpeakerId = useCallback((uid) => {
        if (!uid) return false;
        return (asatizahData || []).some(a => a?.source === "self" && (a.uid === uid || a.id === uid));
    }, [asatizahData]);






    const fetchEvents = useCallback(async () => {



        const buildMonthlyInstances = (r, exDatesSet) => {
            const out = [];
            const start = parseYMD(r.repeatStart);
            const end = parseYMD(r.repeatEnd);
            if (!start || !end || isNaN(start) || isNaN(end)) return out;

            // ====== derive "Jumaat minggu ke-berapa" dari repeatStart jika field baru tak wujud ======
            const base = parseYMD(r.repeatStart);

            const weekOfMonth = (d) => Math.floor((d.getDate() - 1) / 7) + 1;
            const isLastSameDowInMonth = (d) => {
                const x = new Date(d);
                x.setDate(x.getDate() + 7);
                return x.getMonth() !== d.getMonth();
            };

            const dow = (r.repeatDow !== undefined && r.repeatDow !== null)
                ? Number(r.repeatDow)
                : base.getDay();

            const nth = (r.repeatNth !== undefined && r.repeatNth !== null)
                ? Number(r.repeatNth)
                : (isLastSameDowInMonth(base) ? -1 : weekOfMonth(base));

            // helper kecil: dapatkan tarikh nth weekday untuk bulan tersebut
            const getNthDowDate = (y, mi, dow, nth) => {
                if (nth === -1) {
                    const last = new Date(y, mi + 1, 0);
                    const back = (last.getDay() - dow + 7) % 7;
                    last.setDate(last.getDate() - back);
                    return last;
                }

                const first = new Date(y, mi, 1);
                const fwd = (dow - first.getDay() + 7) % 7;
                const day = 1 + fwd + (nth - 1) * 7;
                const d = new Date(y, mi, day);
                if (d.getMonth() !== mi) return null; // bulan tu tak cukup minggu
                return d;
            };

            let cur = new Date(start.getFullYear(), start.getMonth(), 1);

            while (cur <= end) {
                const y = cur.getFullYear();
                const mi = cur.getMonth();

                const date = getNthDowDate(y, mi, dow, nth);
                if (!date) {
                    cur.setMonth(cur.getMonth() + 1);
                    continue;
                }

                if (date < start) {
                    cur.setMonth(cur.getMonth() + 1);
                    continue;
                }
                if (date > end) break;

                const ymd = toYMD(date);
                if (!exDatesSet?.has(ymd)) {
                    out.push({
                        id: `${r.seriesId}__${ymd}`,
                        title: r.title,
                        start: buildStartFromDateTime(date, r.time || "00:00"),
                        end: null,
                        allDay: false,
                        extendedProps: {
                            ...r,
                            // inject supaya PopEvent/Edit tahu dia nth-based walaupun data lama
                            repeatDow: dow,
                            repeatNth: nth,
                            isRecurring: true,
                            seriesId: r.seriesId,
                            time: r.time || "",
                        },
                    });
                }

                cur.setMonth(cur.getMonth() + 1);
            }

            return out;
        };




        try {
            if (!mosqueId) return;

            const docRef = doc(db, "masajid", mosqueId);
            const docSnapshot = await getDoc(docRef);

            if (!docSnapshot.exists()) {
                console.log("No data found for mosqueId:", mosqueId);
                return;
            }

            const data = docSnapshot.data();

            // ===============================
            // ✅ Load recurring rules from subcollection (NEW)
            // ===============================
            let kuliahRecurringSub = [];
            let programRecurringSub = [];

            try {
                const snap = await getDocs(collection(db, "masajid", mosqueId, "kuliahRecurring"));
                kuliahRecurringSub = snap.docs.map(d => {
                    const r = d.data() || {};
                    return { ...r, seriesId: r.seriesId || d.id }; // fallback seriesId
                });
            } catch (e) {
                console.warn("❌ Subcollection kuliahRecurring gagal:", e);
            }

            try {
                const snap = await getDocs(collection(db, "masajid", mosqueId, "programRecurring"));
                programRecurringSub = snap.docs.map(d => {
                    const r = d.data() || {};
                    return { ...r, seriesId: r.seriesId || d.id };
                });
            } catch (e) {
                console.warn("❌ Subcollection programRecurring gagal:", e);
            }

            // ✅ Merge legacy (array dalam doc) + subcollection (prefer subcollection override)
            const mergeBySeriesId = (legacyArr, subArr) => {
                const map = new Map();
                (legacyArr || []).forEach(r => r?.seriesId && map.set(r.seriesId, r));
                (subArr || []).forEach(r => r?.seriesId && map.set(r.seriesId, r)); // override legacy
                return [...map.values()];
            };

            const kuliahRecurringAll = mergeBySeriesId(data.aktiviti?.kuliahRecurring, kuliahRecurringSub);
            const programRecurringAll = mergeBySeriesId(data.aktiviti?.programRecurring, programRecurringSub);



            // ===============================
            // ✅ Build speakerMap (live data ustaz from Asatizah)
            // ===============================
            const speakerIds = new Set();

            (data.aktiviti?.kuliah || []).forEach((e) => e.speakerId && speakerIds.add(e.speakerId));
            kuliahRecurringAll.forEach((r) => r.speakerId && speakerIds.add(r.speakerId));


            const getSpeakerData = async (uid) => {
                if (!uid) return null;

                const s1 = await getDoc(doc(firestoreAsatizah, "asatizah", uid));
                if (s1.exists()) return { id: uid, ...s1.data() };

                const s2 = await getDoc(doc(firestore, "asatizah", uid)); // ✅ admin db
                if (s2.exists()) return { id: uid, ...s2.data() };

                return null;
            };

            const speakerMap = {};
            await Promise.all(
                [...speakerIds].map(async (uid) => {
                    const sp = await getSpeakerData(uid);
                    if (!sp) return;

                    const rawImg = pickSpeakerImage(sp, "");
                    const img = await resolveMaybeStorageUrl(rawImg);

                    speakerMap[uid] = { ...sp, __img: img };
                })
            );

            // ✅ fallback utk event lama: match by nama
            const speakerByName = {};
            Object.values(speakerMap).forEach((sp) => {
                const key = normalizeName(sp?.nama);
                if (key && !speakerByName[key]) speakerByName[key] = sp;
            });



            // ===============================
            // ✅ Recurring Exceptions (EXDATE)
            // ===============================
            const kuliahExc = data.aktiviti?.kuliahRecurringExceptions || [];
            const programExc = data.aktiviti?.programRecurringExceptions || [];

            const exMapKul = {};
            kuliahExc.forEach((x) => {
                if (!x?.seriesId || !x?.dateYMD) return;
                (exMapKul[x.seriesId] ||= []).push(x.dateYMD);
            });

            const exMapProg = {};
            programExc.forEach((x) => {
                if (!x?.seriesId || !x?.dateYMD) return;
                (exMapProg[x.seriesId] ||= []).push(x.dateYMD);
            });


            if (data?.profail) {
                setMosqueNameState(data.profail.nama || "Masjid");
                setMosqueLogoUrlState(data.profail.logo || "");
            }

            setEtvColorState(data?.etv?.etvColor || "#7A1777");

            const fetchedEvents = [];

            const api = calendarRef.current?.getApi();
            const viewStart = api?.view?.activeStart || new Date();
            const viewEnd = api?.view?.activeEnd || new Date(viewStart.getTime() + 45 * 86400000);

            // ===============================
            // ✅ Build set untuk elak duplicate (subcollection vs legacy)
            // ===============================
            const seenSingleIds = new Set();

            // helper: check dalam view untuk legacy supaya tak berat
            const inView = (startDate) => {
                if (!startDate) return false;
                const t = startDate.getTime ? startDate.getTime() : new Date(startDate).getTime();
                return t >= viewStart.getTime() && t < viewEnd.getTime();
            };

            // ===============================
            // ✅ 1) Fetch singles dari subcollection (kuliah/program)
            // ===============================
            try {
                const kuliahCol = collection(db, "masajid", mosqueId, "kuliah");
                const qKul = query(
                    kuliahCol,
                    where("start", ">=", viewStart),
                    where("start", "<", viewEnd),
                    orderBy("start", "asc")
                );

                const kulSnap = await getDocs(qKul);

                kulSnap.forEach((d) => {
                    const ev = d.data() || {};

                    const start = ev.start?.toDate
                        ? ev.start.toDate()
                        : (ev.start?.seconds ? new Date(ev.start.seconds * 1000) : ev.start || null);

                    const end = ev.end?.toDate
                        ? ev.end.toDate()
                        : (ev.end?.seconds ? new Date(ev.end.seconds * 1000) : ev.end || null);

                    // ✅ ENRICH speaker untuk event subcollection
                    const sp =
                        (ev.speakerId && speakerMap[ev.speakerId]) ||
                        (ev.speaker && speakerByName[normalizeName(ev.speaker)]) ||
                        null;

                    const speaker = sp?.nama || ev.speaker || "";
                    const speakerImage = pickSpeakerImage(sp, ev.speakerImage || "");
                    const speakerPosition = sp?.jawatan || ev.speakerPosition || "";

                    fetchedEvents.push({
                        id: d.id,
                        title: ev.title || "Kuliah",
                        start,
                        end,
                        allDay: !!ev.allDay,
                        extendedProps: {
                            ...ev,
                            isKuliah: true,
                            speakerId: ev.speakerId || null,
                            speaker,
                            speakerImage,
                            speakerPosition,
                        },
                    });

                    // ✅ dedupe key: docId + (kalau ada) eventId field
                    seenSingleIds.add(d.id);
                    if (ev.eventId) seenSingleIds.add(ev.eventId);
                });

            } catch (e) {
                console.warn("❌ Subcollection kuliah gagal:", e);
                toast.error(`Subcollection kuliah gagal: ${e?.code || e?.message || "unknown"}`);
            }

            try {
                const progCol = collection(db, "masajid", mosqueId, "program");
                const qProg = query(
                    progCol,
                    where("start", ">=", viewStart),
                    where("start", "<", viewEnd),
                    orderBy("start", "asc")
                );

                const progSnap = await getDocs(qProg);

                progSnap.forEach((d) => {
                    const ev = d.data() || {};
                    const start = ev.start?.toDate ? ev.start.toDate()
                        : (ev.start?.seconds ? new Date(ev.start.seconds * 1000) : ev.start || null);

                    const end = ev.end?.toDate ? ev.end.toDate()
                        : (ev.end?.seconds ? new Date(ev.end.seconds * 1000) : ev.end || null);

                    fetchedEvents.push({
                        id: d.id,
                        title: ev.title || "Program",
                        start,
                        end,
                        allDay: !!ev.allDay,
                        extendedProps: { ...ev, isKuliah: false },
                    });

                    seenSingleIds.add(d.id);
                    if (ev.eventId) seenSingleIds.add(ev.eventId);
                });
            } catch (e) {
                console.warn("❌ Subcollection program gagal:", e);
                toast.error(`Subcollection program gagal: ${e?.code || e?.message || "unknown"}`);
            }

            // ===============================
            // ✅ 2) Masukkan legacy singles walaupun subcollection wujud
            //    (tapi skip yang dah ada)
            // ===============================
            if (data.aktiviti?.kuliah) {
                const singles = (data.aktiviti.kuliah || []).filter(e => !e?.isGenerated);

                singles.forEach((event) => {
                    const legacyId = event.eventId;
                    if (!legacyId) return;
                    if (seenSingleIds.has(legacyId)) return;

                    const start = event.start?.toDate ? event.start.toDate()
                        : (event.start?.seconds ? new Date(event.start.seconds * 1000) : null);

                    // optional: hanya push kalau dalam view (kalau nak)
                    if (!inView(start)) return;

                    const sp =
                        (event.speakerId && speakerMap[event.speakerId]) ||
                        (event.speaker && speakerByName[normalizeName(event.speaker)]) ||
                        null;

                    fetchedEvents.push({
                        id: legacyId,
                        title: event.title,
                        start,
                        end: event.end?.toDate ? event.end.toDate()
                            : (event.end?.seconds ? new Date(event.end.seconds * 1000) : null),
                        allDay: event.allDay || false,
                        extendedProps: {
                            speakerId: event.speakerId || null,
                            speaker: sp?.nama || event.speaker || "",
                            speakerImage: pickSpeakerImage(sp, event.speakerImage || ""),
                            speakerPosition: sp?.jawatan || event.speakerPosition || "",
                            subjek: event.subjek || "",
                            tajuk: event.tajuk || "",
                            time: event.time || "",
                            nota: event.nota || "",
                            kitabId: event.kitabId || null,
                            kitabTitle: event.kitabTitle || "",
                            kitabCoverImage: event.kitabCoverImage || "",
                            kitabCategory: event.kitabCategory || "",
                            kitabAuthor: event.kitabAuthor || "",
                            isKuliah: true,
                        },
                    });

                    seenSingleIds.add(legacyId);
                });
            }

            if (data.aktiviti?.program) {
                const singles = (data.aktiviti.program || []).filter(e => !e?.isGenerated);

                singles.forEach((event) => {
                    const legacyId = event.eventId;
                    if (!legacyId) return;
                    if (seenSingleIds.has(legacyId)) return;

                    const start = event.start?.toDate ? event.start.toDate()
                        : (event.start?.seconds ? new Date(event.start.seconds * 1000) : null);

                    if (!inView(start)) return;

                    fetchedEvents.push({
                        id: legacyId,
                        title: event.title,
                        start,
                        end: event.end?.toDate ? event.end.toDate()
                            : (event.end?.seconds ? new Date(event.end.seconds * 1000) : null),
                        allDay: event.allDay || false,
                        extendedProps: {
                            posterImage: event.posterImage || "",
                            isPosterToEtv: !!event.isPosterToEtv,
                            time: event.time || "",
                            isKuliah: false,
                        },
                    });

                    seenSingleIds.add(legacyId);
                });
            }


            if (kuliahRecurringAll.length) {
                const api = calendarRef.current?.getApi();
                const viewStart = api?.view?.activeStart || new Date();
                const viewEnd = api?.view?.activeEnd || new Date(viewStart.getTime() + 45 * 86400000);

                kuliahRecurringAll.forEach((r) => {
                    const sp =
                        (r.speakerId && speakerMap[r.speakerId]) ||
                        (r.speaker && speakerByName[normalizeName(r.speaker)]) ||
                        null;

                    const seriesId = r.seriesId;
                    const exSet = new Set(exMapKul[seriesId] || []);

                    const seriesStart = parseYMD(r.repeatStart);
                    const seriesEnd = parseYMD(r.repeatEnd);

                    // clamp ikut view
                    const start = new Date(Math.max(viewStart.getTime(), seriesStart.getTime()));
                    const end = new Date(Math.min(viewEnd.getTime(), seriesEnd.getTime() + 86400000)); // inclusive end

                    // ✅ MONTHLY: guna helper buildMonthlyInstances, tapi limit ikut view
                    if (r.repeat === "monthly") {
                        // build bulan demi bulan dalam range series, kemudian filter ikut viewStart/viewEnd
                        const all = buildMonthlyInstances(r, exSet);

                        all.forEach((ev) => {
                            if (!ev.start) return;
                            if (ev.start < viewStart || ev.start >= viewEnd) return;

                            fetchedEvents.push({
                                ...ev,
                                extendedProps: {
                                    ...ev.extendedProps,
                                    isKuliah: true,
                                    // inject live asatizah
                                    speakerId: r.speakerId || null,
                                    speaker: sp?.nama || r.speaker || "",
                                    speakerImage: pickSpeakerImage(sp, r.speakerImage || ""),
                                    speakerPosition: sp?.jawatan || r.speakerPosition || "",
                                },
                            });
                        });

                        return;
                    }

                    const base = parseYMD(r.repeatStart);
                    const dow = (r.repeatDow !== undefined && r.repeatDow !== null)
                        ? Number(r.repeatDow)
                        : base.getDay();

                    for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
                        const ymd = toYMD(d);
                        if (d.getDay() !== dow) continue;
                        if (exSet.has(ymd)) continue;

                        fetchedEvents.push({
                            id: `${seriesId}__${ymd}`,        // unique id per occurrence
                            groupId: seriesId,
                            title: r.title,
                            start: buildStartFromDateTime(d, r.time),
                            allDay: false,
                            extendedProps: {
                                isKuliah: true,
                                isRecurring: true,
                                seriesId,
                                occurrenceYMD: ymd,
                                repeat: r.repeat,
                                repeatMode: r.repeatMode || "",
                                repeatDow: dow,
                                repeatNth: r.repeatNth ?? null,
                                repeatDom: r.repeatDom,
                                repeatStart: r.repeatStart,
                                repeatEnd: r.repeatEnd,

                                speakerId: r.speakerId || null,
                                speaker: sp?.nama || r.speaker || "",
                                speakerImage: pickSpeakerImage(sp, r.speakerImage || ""),
                                speakerPosition: sp?.jawatan || r.speakerPosition || "",

                                subjek: r.subjek || "",
                                tajuk: r.tajuk || "",
                                nota: r.nota || "",
                                time: r.time || "",

                                kitabId: r.kitabId || null,
                                kitabTitle: r.kitabTitle || "",
                                kitabCoverImage: r.kitabCoverImage || "",
                                kitabCategory: r.kitabCategory || "",
                                kitabAuthor: r.kitabAuthor || "",
                            },
                        });
                    }
                });

            }


            if (programRecurringAll.length) {

                // ✅ Recurring: Program (expand to instances + apply exceptions)
                const api = calendarRef.current?.getApi();
                const viewStart = api?.view?.activeStart || new Date();
                const viewEnd = api?.view?.activeEnd || new Date(viewStart.getTime() + 45 * 86400000);

                programRecurringAll.forEach((r) => {
                    const seriesId = r.seriesId;
                    const exSet = new Set(exMapProg[seriesId] || []);

                    const seriesStart = parseYMD(r.repeatStart);
                    const seriesEnd = parseYMD(r.repeatEnd);

                    const start = new Date(Math.max(viewStart.getTime(), seriesStart.getTime()));
                    const end = new Date(Math.min(viewEnd.getTime(), seriesEnd.getTime() + 86400000));

                    // ✅ MONTHLY
                    if (r.repeat === "monthly") {
                        const all = buildMonthlyInstances(r, exSet);

                        all.forEach((ev) => {
                            if (!ev.start) return;
                            if (ev.start < viewStart || ev.start >= viewEnd) return;

                            fetchedEvents.push({
                                ...ev,
                                extendedProps: {
                                    ...ev.extendedProps,
                                    isKuliah: false,
                                    posterImage: r.posterImage || "",
                                    isPosterToEtv: !!r.isPosterToEtv,
                                },
                            });
                        });

                        return;
                    }

                    // ✅ WEEKLY
                    for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
                        const ymd = toYMD(d);
                        const dow = Number(r.repeatDow);
                        if (d.getDay() !== dow) continue;
                        if (exSet.has(ymd)) continue;

                        fetchedEvents.push({
                            id: `${seriesId}__${ymd}`,
                            groupId: seriesId,
                            title: r.title,
                            start: buildStartFromDateTime(d, r.time),
                            allDay: false,
                            extendedProps: {
                                isKuliah: false,
                                isRecurring: true,
                                seriesId,
                                occurrenceYMD: ymd,
                                repeat: r.repeat,
                                repeatMode: r.repeatMode || "",
                                repeatDow: dow,
                                repeatNth: r.repeatNth ?? null,
                                repeatDom: r.repeatDom,
                                repeatStart: r.repeatStart,
                                repeatEnd: r.repeatEnd,
                                time: r.time || "",
                                posterImage: r.posterImage || "",
                                isPosterToEtv: !!r.isPosterToEtv,
                            },
                        });
                    }
                });

            }

            await Promise.all(
                fetchedEvents.map(async (ev) => {
                    const ep = ev?.extendedProps;
                    if (!ep) return;

                    if (ep.speakerImage) ep.speakerImage = await resolveMaybeStorageUrl(ep.speakerImage);
                    if (ep.posterImage) ep.posterImage = await resolveMaybeStorageUrl(ep.posterImage);
                })
            );




            setEvents(fetchedEvents);
        } catch (error) {
            console.error("❌ Error fetching events:", error);
        }
    }, [mosqueId]);

    useEffect(() => {
        let alive = true;

        (async () => {
            try {
                // 1) ADMIN (masjid cipta) — dari firestore
                const adminSnap = await getDocs(
                    query(collection(firestore, "asatizah"), orderBy("nama", "asc"))
                );

                const adminRows = adminSnap.docs.map((d) => {
                    const data = d.data() || {};
                    return {
                        id: d.id,
                        uid: null,           // ✅ PENTING: admin TAK ADA uid
                        source: "admin",
                        ...data,
                    };
                });

                // 2) SELF (ustaz ada akaun app asatizah) — dari firestoreAsatizah
                const selfSnap = await getDocs(
                    query(collection(firestoreAsatizah, "asatizah"), orderBy("nama", "asc"))
                );

                const selfRows = selfSnap.docs.map((d) => {
                    const data = d.data() || {};
                    return {
                        id: d.id,
                        uid: d.id,           // ✅ self uid = docId
                        source: "self",
                        ...data,
                    };
                });

                // merge + sort
                const combined = [...adminRows, ...selfRows]
                    .filter((x) => x?.nama)
                    .sort((a, b) => String(a.nama).toLowerCase().localeCompare(String(b.nama).toLowerCase()));

                if (!alive) return;
                setAsatizahData(combined);
            } catch (e) {
                console.warn("❌ fetch asatizah list (admin+self) gagal:", e?.code || e?.message || e);
                if (!alive) return;
                setAsatizahData([]);
            }
        })();

        return () => { alive = false; };
    }, []);



    const deleteSeriesRule = async (colName, seriesId) => {
        const speakerIds = new Set();
        const deletedIds = [];

        // 1) try direct docId == seriesId
        const directRef = doc(db, "masajid", mosqueId, colName, seriesId);
        const directSnap = await getDoc(directRef);

        if (directSnap.exists()) {
            const data = directSnap.data() || {};
            if (data.speakerId) speakerIds.add(data.speakerId);

            console.log(`[deleteSeriesRule] deleting direct ${colName}/${seriesId}`);
            await deleteEvent(mosqueId, seriesId, { legacyCollection: colName });

            deletedIds.push(seriesId);
            return { deleted: true, method: "direct", count: 1, deletedIds, speakerIds: [...speakerIds] };
        }

        // 2) try query by field seriesId
        const colRef = collection(db, "masajid", mosqueId, colName);
        const qy = query(colRef, where("seriesId", "==", seriesId));
        const snap = await getDocs(qy);

        console.log(`[deleteSeriesRule] query ${colName} seriesId=${seriesId} count=${snap.size}`);
        if (snap.empty) return { deleted: false, method: "none", count: 0, deletedIds: [], speakerIds: [] };

        await Promise.all(
            snap.docs.map(async (d) => {
                const data = d.data() || {};
                if (data.speakerId) speakerIds.add(data.speakerId);
                deletedIds.push(d.id);
                await deleteEvent(mosqueId, d.id, { legacyCollection: colName });
            })
        );

        return { deleted: true, method: "query", count: snap.size, deletedIds, speakerIds: [...speakerIds] };
    };



    const deleteIfExists = async (colName, id) => {
        const r = doc(db, "masajid", mosqueId, colName, id);
        const s = await getDoc(r);
        if (!s.exists()) return null;

        const data = s.data() || {};
        await deleteEvent(mosqueId, id, { legacyCollection: colName });

        return { id: s.id, data, colName };
    };



    const deleteEventFromFirestore = async (eventId) => {
        try {
            console.log("[deleteEventFromFirestore] eventId:", eventId);

            // helper sync delete Asatizah
            const deleteAsatizahDoc = async (speakerId, sub, id) => {
                if (!speakerId || !id) return;
                try {
                    await deleteDoc(doc(firestoreAsatizah, `asatizah/${speakerId}/${sub}/${id}`));
                    console.log("✅ Sync delete Asatizah:", speakerId, sub, id);
                } catch (e) {
                    console.warn("⚠️ Sync delete Asatizah failed:", e?.code || e?.message || e);
                }
            };

            // ✅ 0) delete single event (subcollection)
            const kulDel = await deleteIfExists("kuliah", eventId);
            if (kulDel) {
                // ⭐ penting: subcollection kuliah ada speakerId (sebab AddEvent simpan speakerId)
                const speakerId = kulDel.data?.speakerId || null;
                if (speakerId) await deleteAsatizahDoc(speakerId, "events", eventId);

                toast.success("Event berjaya dipadam.");
                fetchEvents();
                return;
            }

            const progDel = await deleteIfExists("program", eventId);
            if (progDel) {
                // program tak perlu sync ke asatizah (ustaz view tak simpan program dalam events)
                toast.success("Event berjaya dipadam.");
                fetchEvents();
                return;
            }

            // ✅ 0.5) delete recurring rule (SERIES) + sync Asatizah recurring
            const delKul = await deleteSeriesRule("kuliahRecurring", eventId);
            if (delKul.deleted) {
                // doc Asatizah recurring guna id = seriesId (AddEvent syncSeriesToAsatizah rule.seriesId)
                await Promise.all(
                    (delKul.speakerIds || []).map((sid) => deleteAsatizahDoc(sid, "recurring", eventId))
                );

                toast.success(`Series berjaya dipadam. (${delKul.method}, ${delKul.count})`);
                fetchEvents();
                return;
            }

            const delProg = await deleteSeriesRule("programRecurring", eventId);
            if (delProg.deleted) {
                // programRecurring biasanya tak sync ke Asatizah recurring (sebab bukan kuliah)
                toast.success(`Series berjaya dipadam. (${delProg.method}, ${delProg.count})`);
                fetchEvents();
                return;
            }

            // ============================
            // ✅ fallback legacy (dokumen masjid: aktiviti.*)
            // ============================
            const docRef = doc(db, "masajid", mosqueId);
            const docSnapshot = await getDoc(docRef);

            if (!docSnapshot.exists()) {
                toast.error("Dokumen masjid tidak wujud.");
                return;
            }

            const data = docSnapshot.data();
            const aktiviti = data.aktiviti || {};

            const kuliahRecurring = aktiviti.kuliahRecurring || [];
            const programRecurring = aktiviti.programRecurring || [];

            // ✅ 1) kalau recurring legacy, padam series dulu & stop
            if (kuliahRecurring.some(e => e.seriesId === eventId)) {
                const updated = kuliahRecurring.filter(e => e.seriesId !== eventId);
                await updateDoc(docRef, { "aktiviti.kuliahRecurring": updated });
                toast.success("Series berjaya dipadam.");
                fetchEvents();
                return;
            }

            if (programRecurring.some(e => e.seriesId === eventId)) {
                const updated = programRecurring.filter(e => e.seriesId !== eventId);
                await updateDoc(docRef, { "aktiviti.programRecurring": updated });
                toast.success("Series berjaya dipadam.");
                fetchEvents();
                return;
            }

            // ✅ 2) barulah handle single event legacy
            const kuliah = aktiviti.kuliah || [];
            const program = aktiviti.program || [];

            const inKuliah = kuliah.find(e => e.eventId === eventId);
            const inProgram = program.find(e => e.eventId === eventId);

            if (!inKuliah && !inProgram) {
                toast.error("Event tidak dijumpai.");
                return;
            }

            const field = inKuliah ? "kuliah" : "program";
            const deletedEvent = inKuliah || inProgram;

            const updatedField = (aktiviti[field] || []).filter(e => e.eventId !== eventId);
            await updateDoc(docRef, { [`aktiviti.${field}`]: updatedField });

            // ✅ 3) sync delete ke kalendar ustaz (legacy single kuliah sahaja) — kekalkan code asal kau
            if (field === "kuliah" && deletedEvent?.speaker) {
                const ustazSnap = await getDocs(collection(firestoreAsatizah, "asatizah"));
                const ustazDoc = ustazSnap.docs.find(docu => docu.data().nama === deletedEvent.speaker);

                if (ustazDoc) {
                    const userUid = ustazDoc.id;
                    const eventCollection = collection(firestoreAsatizah, `asatizah/${userUid}/events`);
                    const snapshot = await getDocs(eventCollection);

                    for (const docu of snapshot.docs) {
                        if (docu.data().eventId === eventId) {
                            await deleteDoc(docu.ref);
                        }
                    }
                }
            }

            toast.success("Event berjaya dipadam.");
            fetchEvents();
        } catch (error) {
            console.error("Error deleting event:", error);
            toast.error("Gagal padam event.");
        }
    };





    const closeModalTambah = () => {
        setModalTambah(false);
        setEventTitle('');
        setSpeakerName('');
        setSpeakerImage('');
        setSpeakerPosition('');
        setPosterImage('');
        setStartTime('19:30');
        setSelectedEvent(null);
        setSelectedDate(null);
        setEventId(null);
        setPendingException(null);
    };

    const closeModalProgram = () => {
        setModalProgram(false);
    };

    const dayHeaderContent = (arg) => {
        const days = isMobile
            ? ['Aha', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab']
            : ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'];

        const defaultTextColor = '#7A1777';
        const fridayTextColor = '#007000'; // Green color for Jumaat

        const textColor = arg.date.getDay() === 5 ? fridayTextColor : defaultTextColor; // Check if the day is Friday (5)

        return (
            <span style={{ color: textColor }}>
                {days[arg.date.getDay()]}
            </span>
        );
    };


    const handleDateClick = (arg) => {
        resetAddForm();                 // ✅ kosongkan semua
        setSelectedDate(arg.date);      // ✅ set tarikh
        setAddFormNonce(n => n + 1);    // ✅ paksa AddEvent remount
        setModalTambah(true);
    };


    const renderEventContent = (eventInfo) => {
        const poster = safeImg(eventInfo.event.extendedProps.posterImage);
        const speakerImg = safeImg(eventInfo.event.extendedProps.speakerImage);

        return (
            <div style={{ width: "100%", overflow: "hidden" }}>
                {poster ? (
                    <div style={{ display: "flex", alignItems: "center", paddingLeft: "5px", paddingRight: "5px" }}>
                        <img
                            src={poster}
                            alt="Poster Pic"
                            style={{ width: "50px", height: "34px", objectFit: "fill", marginRight: "10px" }}
                            onError={(e) => (e.currentTarget.style.display = "none")}
                        />
                        <p style={{ color: "black", fontSize: "14px", margin: "0", flex: "1", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {eventInfo.event.title}
                        </p>
                    </div>
                ) : (
                    <div style={{ display: "flex", alignItems: "center", paddingLeft: "5px", paddingRight: "5px" }}>
                        <div style={{ flex: "1", marginRight: "10px", overflow: "hidden" }}>
                            <p style={{ color: "black", fontSize: "14px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: "0" }}>
                                {eventInfo.event.title}
                            </p>
                            <p style={{ color: "black", fontSize: "12px", marginTop: "-2px", marginBottom: "0" }}>
                                {eventInfo.event.extendedProps.speaker}
                            </p>
                        </div>

                        <div>
                            {speakerImg ? (
                                <img
                                    crossOrigin="anonymous"
                                    src={speakerImg}
                                    alt="Speaker Pic"
                                    style={{ width: "34px", height: "34px", borderRadius: "50%" }}
                                    onError={(e) => (e.currentTarget.style.display = "none")}
                                />
                            ) : (
                                <div style={{ width: 34, height: 34, borderRadius: "50%", background: "#ddd" }} />
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    };


    const handleEventClick = (eventClickInfo) => {
        setSelectedEvent(eventClickInfo.event);
        setModalProgram(true);
    };

    const handleEditEvent = async (payload) => {
        // payload: { scope, eventId, occurrenceYMD }
        // fallback lama: kalau masih terima event object
        if (!payload || payload?.title) {
            // old behavior
            const ev = payload;
            setSelectedEvent(ev);
            setModalProgram(false);
            setModalTambah(true);
            return;
        }

        const { scope, eventId, occurrenceYMD } = payload || {};
        if (!eventId) return;

        // source event ialah selectedEvent (yang user click)
        const ev = selectedEvent;
        if (!ev) return;
        // ✅ tambah event baru serupa (tanpa EXDATE)
        if (scope === "add") {
            const isKuliah = !!ev?.extendedProps?.isKuliah;

            if (!occurrenceYMD) {
                toast.error("Tarikh tidak sah.");
                return;
            }

            const d = parseYMD(occurrenceYMD);
            setSelectedDate(d);

            // treat as NEW event
            setEventId(null);
            setSelectedEvent(ev);

            // prefill
            setEventTitle(ev.title || "");
            setStartTime(ev.extendedProps?.time || "19:30");

            if (isKuliah) {
                setSpeakerName(ev.extendedProps?.speaker || "");
                setSpeakerImage(safeImg(ev.extendedProps?.speakerImage || ""));
                setSpeakerPosition(ev.extendedProps?.speakerPosition || "");
                // kalau nak prefill kitab/nota pun boleh (kalau state ada di AddEvent)
            } else {
                setPosterImage(ev.extendedProps?.posterImage || "");
            }

            setModalProgram(false);
            setModalTambah(true);
            return;
        }

        // ✅ kalau edit tarikh ini sahaja (override):
        // 1) add EXDATE untuk hide occurrence
        // 2) buka AddEvent sebagai "Tambah" (eventId null) dengan field siap
        if (scope === "one") {
            const isKuliah = !!ev?.extendedProps?.isKuliah;
            if (!occurrenceYMD) {
                toast.error("Tarikh tidak sah.");
                return;
            }

            // ✅ JANGAN commit EXDATE lagi — simpan dulu
            setPendingException({
                seriesId: eventId,
                dateYMD: occurrenceYMD,
                isKuliah,
            });

            // prefill fields untuk tambah single event pada tarikh itu
            const d = parseYMD(occurrenceYMD);
            setSelectedDate(d);

            setEventId(null); // treat as NEW single
            setSelectedEvent(ev);

            setEventTitle(ev.title || "");
            setStartTime(ev.extendedProps?.time || "19:30");

            if (isKuliah) {
                setSpeakerName(ev.extendedProps?.speaker || "");
                setSpeakerImage(safeImg(ev.extendedProps?.speakerImage || ""));
                setSpeakerPosition(ev.extendedProps?.speakerPosition || "");
            } else {
                setPosterImage(ev.extendedProps?.posterImage || "");
            }

            // tutup popup, buka AddEvent
            setModalProgram(false);
            setModalTambah(true);
            return;
        }


        // ✅ edit semua siri (series)
        if (scope === "series") {
            setEventTitle(ev.title || "");
            setStartTime(ev.extendedProps?.time || "19:30");

            // untuk recurring, gunakan seriesId, bukan id instance
            setEventId(eventId);
            setSelectedDate(ev.start || new Date());
            setSelectedEvent(ev);

            if (ev.extendedProps?.isKuliah) {
                setSpeakerName(ev.extendedProps?.speaker || "");
                setSpeakerImage(safeImg(ev.extendedProps?.speakerImage || ""));
                setSpeakerPosition(ev.extendedProps?.speakerPosition || "");
            } else {
                setPosterImage(ev.extendedProps?.posterImage || "");
            }

            setModalProgram(false);
            setModalTambah(true);
            return;
        }

        // ✅ single
        if (scope === "single") {
            setEventTitle(ev.title || "");
            setStartTime(ev.extendedProps?.time || "19:30");
            setEventId(ev.id);
            setSelectedDate(ev.start || new Date());
            setSelectedEvent(ev);

            setModalProgram(false);
            setModalTambah(true);
        }
    };


    const addRecurringException = async ({ seriesId, dateYMD, isKuliah }) => {
        const docRef = doc(db, "masajid", mosqueId);
        const snap = await getDoc(docRef);

        if (!snap.exists()) {
            toast.error("Dokumen masjid tidak wujud.");
            return;
        }

        const data = snap.data();
        const aktiviti = data.aktiviti || {};

        const key = isKuliah ? "kuliahRecurringExceptions" : "programRecurringExceptions";
        const list = aktiviti[key] || [];

        const exists = list.some(x => x?.seriesId === seriesId && x?.dateYMD === dateYMD);
        if (exists) return;

        const next = [...list, { seriesId, dateYMD, createdAt: Date.now() }];

        // ✅ ini asal kau (kekalkan)
        await updateDoc(docRef, { [`aktiviti.${key}`]: next });

        // =========================
        // ✅ sync exDates ke subcollection + Asatizah (tahan lasak)
        // =========================
        try {
            const colName = isKuliah ? "kuliahRecurring" : "programRecurring";
            const seriesRef = doc(db, "masajid", mosqueId, colName, seriesId);
            const seriesSnap = await getDoc(seriesRef);

            if (seriesSnap.exists()) {
                const seriesData = seriesSnap.data() || {};
                const cur = Array.isArray(seriesData.exDates) ? seriesData.exDates : [];

                if (!cur.includes(dateYMD)) {
                    await saveEvent(mosqueId, {
                        ...seriesData,
                        eventId: seriesId,
                        seriesId,
                        exDates: [...cur, dateYMD],
                        updatedAt: Date.now(),
                    }, { legacyCollection: colName });
                }

                // ✅ sync ke Asatizah hanya untuk kuliah (ada speakerId)
                // ✅ sync ke Asatizah hanya untuk kuliah + speakerId mesti betul² self UID
                if (isKuliah && seriesData.speakerId && isSelfSpeakerId(seriesData.speakerId)) {
                    const asRef = doc(
                        firestoreAsatizah,
                        `asatizah/${seriesData.speakerId}/recurring/${seriesId}`
                    );
                    const asSnap = await getDoc(asRef);

                    // ✅ jangan create doc kalau tak wujud
                    if (!asSnap.exists()) return;

                    const cur2 = Array.isArray(asSnap.data()?.exDates) ? asSnap.data().exDates : [];
                    if (!cur2.includes(dateYMD)) {
                        await updateDoc(asRef, {
                            exDates: [...cur2, dateYMD],
                            updatedAt: Date.now(),
                        });
                    }
                }

            }
        } catch (e) {
            console.warn("⚠️ sync exDates gagal:", e?.code || e?.message || e);
        }

    };

    const commitPendingException = async () => {
        if (!pendingException?.seriesId || !pendingException?.dateYMD) return;

        await addRecurringException(pendingException);
        setPendingException(null);
        await fetchEvents();
    };


    const handleDeleteEvent = async (payload) => {
        // ✅ LOG WAJIB letak kat sini (paling atas), sebelum apa-apa return
        console.log("[handleDeleteEvent] payload:", payload);
        console.log("[handleDeleteEvent] selectedEvent.id:", selectedEvent?.id);
        console.log("[handleDeleteEvent] selectedEvent.seriesId:", selectedEvent?.extendedProps?.seriesId);
        console.log("[handleDeleteEvent] selectedEvent.isRecurring:", selectedEvent?.extendedProps?.isRecurring);
        console.log("[handleDeleteEvent] selectedEvent.isKuliah:", selectedEvent?.extendedProps?.isKuliah);

        try {
            if (typeof payload === "string") {
                await deleteEventFromFirestore(payload);
                closeModalProgram();
                return;
            }

            const { scope, eventId, occurrenceYMD } = payload || {};
            if (!eventId) return;

            if (scope === "single") {
                await deleteEventFromFirestore(eventId);
                closeModalProgram();
                return;
            }

            if (scope === "series") {
                // ✅ paling penting: seriesId mesti betul
                const seriesId = selectedEvent?.extendedProps?.seriesId || eventId;

                console.log("[DELETE SERIES] using seriesId:", seriesId);

                await deleteEventFromFirestore(seriesId);
                closeModalProgram();
                return;
            }

            if (scope === "one") {
                const isKuliah = !!selectedEvent?.extendedProps?.isKuliah;
                if (!occurrenceYMD) {
                    toast.error("Tarikh tidak sah.");
                    return;
                }

                await addRecurringException({ seriesId: eventId, dateYMD: occurrenceYMD, isKuliah });
                toast.success("Tarikh ini berjaya dipadam.");
                fetchEvents();
                closeModalProgram();
                return;
            }

            await deleteEventFromFirestore(eventId);
            closeModalProgram();
        } catch (error) {
            console.error("handleDeleteEvent error:", error);
            toast.error("Gagal padam event.");
        }
    };

    const handleCopyAsNew = ({ targetYMD }) => {
        if (!targetYMD) return;

        const [y, m, d] = String(targetYMD).split("-").map(Number);
        const nextDate = new Date(y, (m || 1) - 1, d || 1); // local midnight

        // ✅ tukar tarikh baru
        setSelectedDate(nextDate);

        // ✅ force jadi "Tambah" (bukan edit)
        setEventId(null);
        setSelectedEvent(null);

        // ✅ ensure UI state betul
        setModalProgram(false);
        setModalTambah(true);
    };




    const handleGeneratePdf = async () => {
        if (isGeneratingPdf) return;
        try {
            setIsGeneratingPdf(true);

            const api = calendarRef.current?.getApi();
            const currentDate = api ? api.getDate() : new Date();

            // ✅ ambil instances yang sedang dirender (monthly view)
            const instanceEvents = api
                ? api.getEvents().map(ev => ({
                    id: ev.id,
                    title: ev.title,
                    start: ev.start,
                    end: ev.end,
                    allDay: ev.allDay,
                    extendedProps: ev.extendedProps,
                }))
                : events;

            await generateCalendarPdf({
                events: instanceEvents,
                currentDate,
                mosqueName: mosqueNameState || "Masjid",
                logoUrl: mosqueLogoUrlState || "",
                etvColor: etvColorState || "#7A1777",
            });
        } catch (err) {
            console.error("Gagal jana PDF:", err);
            toast.error("Gagal jana PDF. Cuba lagi.");
        } finally {
            setIsGeneratingPdf(false);
        }
    };







    return (

        <div>

            <div className="calendar-wrapper">

                <button
                    type="button"
                    onClick={handleGeneratePdf}
                    className="btn-export-pdf calendar-export-btn"
                    disabled={isGeneratingPdf}
                >
                    {isGeneratingPdf ? (
                        <>
                            <FaSpinner className="spin" /> PDF…
                        </>
                    ) : (
                        <>
                            <FaFileDownload /> PDF
                        </>
                    )}
                </button>

                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    ref={calendarRef}
                    initialView={"dayGridMonth"}
                    timeZone="local"
                    locales={[msLocale]}
                    locale="ms"
                    dayHeaderContent={dayHeaderContent}
                    headerToolbar={{
                        start: "title",
                        center: "",
                        end: "prev,next"
                    }}
                    datesSet={() => fetchEvents()}
                    height={"90vh"}
                    events={events}
                    dateClick={handleDateClick}
                    eventContent={renderEventContent}
                    eventClick={handleEventClick}
                    firstDay={1}
                    fixedWeekCount={false}
                    weekNumberCalculation="ISO"
                    showNonCurrentDates={false}
                />

                <p className='aktif-langgan' >
                    V 2.1.20.
                    Aktif sehingga: <strong>
                        {subscriptionEnd
                            ? new Date(subscriptionEnd).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                            : "Unknown"}
                    </strong>
                </p>

                <div>
                    <Modal isOpen={modalTambah} closeModal={closeModalTambah}>
                        <AddEvent
                            key={eventId ? `edit_${eventId}` : `add_${addFormNonce}`}   // ✅ penting
                            asatizahData={asatizahData}
                            startTime={startTime}
                            setStartTime={setStartTime}
                            selectedDate={selectedDate}
                            eventTitle={eventTitle}
                            speakerName={speakerName}
                            speakerImage={speakerImage}
                            speakerPosition={speakerPosition}
                            setEventTitle={setEventTitle}
                            setSpeakerName={setSpeakerName}
                            setSpeakerImage={setSpeakerImage}
                            setSpeakerPosition={setSpeakerPosition}
                            closeModal={closeModalTambah}
                            setPosterImage={setPosterImage}
                            posterImage={posterImage}
                            refreshEvents={fetchEvents}
                            eventId={eventId}
                            selectedEvent={selectedEvent}
                            onCopyAsNew={handleCopyAsNew}
                            pendingException={pendingException}
                            commitPendingException={commitPendingException}
                        />


                    </Modal>
                    <Modal isOpen={modalProgram}
                        closeModal={closeModalProgram}
                    >
                        <EventPopup
                            event={selectedEvent}
                            onClose={closeModalProgram}
                            onDelete={handleDeleteEvent}
                            onEdit={handleEditEvent}
                        />
                    </Modal>

                </div>
            </div>

        </div>
    );
}

export default Calendar;
